<template>
  <nav class="navbar navbar-inverse" :class="{'navbar-animation-state1' : scrollPosition < 100, 'navbar-animation-state2': scrollPosition > 100}">
  <div class="container">
    <!-- Brand and toggle get grouped for better mobile display -->
    <div class="navbar-header">
      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
        <span class="sr-only">Toggle navigation</span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <router-link class="navbar-brand" to="/"><img src="/src/assets/img/logo_colored.png"></router-link>
    </div>

    <!-- Collect the nav links, forms, and other content for toggling -->
    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
    
      <ul class="nav navbar-nav navbar-right">
         <router-link :to="{ name: 'home' }" tag="li">
             <a>الرئيسية</a>
        </router-link>

        <router-link to="/products" tag="li">
            <a>منتجاتنا</a>
        </router-link>
        <router-link to="/news-events" tag="li">
            <a>الأخبار والأنشطة</a>
        </router-link>
        <router-link to="/about-us" tag="li">
            <a>حول الشركة</a>
        </router-link>

      </ul>
        <ul class="nav navbar-nav navbar-left">
          <ul class="top hidden-sm hidden-xs">
              <ul class="social">
                   <li>
                        <a href="https://www.facebook.com/beetronix/" class="fab fa-facebook-square"></a>
                    </li>
                    <li>
                        <a href="https://twitter.com/beetronix_sy" class="fab fa-twitter-square" ></a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/company/beetronix/" class="fab fa-linkedin" ></a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/beetronix/" class="fab fa-instagram" ></a>
                    </li>
              </ul>
              <ul class="contact ">
                   <li>
                        <a href="mailto:info@beetronix.com">
                            <span class="far fa-envelope"></span>
                            <span>info@beetronix.com</span>
                        </a>
                    </li>
                    <li>
                        <a href="callto:00963-993-327-100">
                            <span class="fas fa-phone"></span>
                            <span>00963-993-327-100</span>
                        </a>

                    </li>
              </ul>
          </ul>
          <ul class="bottom">
               <router-link to="/technical-support" tag="li">
                    <a>الدعم الفني</a>
                </router-link>
                <router-link to="/contact-us" tag="li">
                    <a>اتصل بنا</a>
                </router-link>
                <li>
                   <router-link to="/join-us">انضم لنا</router-link>
                </li>
          </ul>
      </ul>
    </div><!-- /.navbar-collapse -->
  </div><!-- /.container-fluid -->
</nav>
</template>
<script>
export default {
  name:'Navbar2',
   data: () => ({
            scrollPosition: null
        }),
 methods: {
            updateScroll() {
                this.scrollPosition = window.scrollY;
            },

            view(route) {
                this.$router.push({
                    name: route
                });
            },

            sectionClicked(id) {
                this.$emit('section-clicked', id);
            }
        },

        mounted() {
            window.addEventListener('scroll', this.updateScroll);

            $(function(){
                $(document).click(function(){
                    if($('.navbar-collapse').hasClass('in')){
                        $('.navbar-collapse').removeClass('in');
                    }
                })
            });
        },

}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/shared/navbar2.vue